<template>
  <div class="math">
    <!-- 遮罩层 -->
    <div class="mask"></div>
    <!--  数学-->
    <div class="item" v-if="status === 1">
      <div :class="['title', status === 1 ? 'animated fadeInUp' : '']">
        <div class="big">心田花开数学</div>
        <div class="small">重提升、强方法、塑思维！</div>
      </div>
      <div :class="['con', status === 1 ? 'animated fadeInUp' : '']">
        “心田花开数学”坚持“知其然更知其所以然”的教学理念，力求在教学中提升学生数学问题的分析和解题能力，培养严密的逻辑思维。不仅要学会题目的解法，也要明白其中的底层逻辑和数学规律。帮助学生养成良好的学习习惯和思维习惯，学会举一反三。
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    status: {
      type: Number,
      default: 0
    }
  }
};
</script>
<style lang="less">
.math {
  height: 100% !important;
  width: 100% !important;
  display: block;
  background: url(../../assets/images/math.png) center no-repeat;
  position: relative;
  background-size: cover;
  .mask {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
    background: rgba(0, 0, 0, 0.6);
    height: 100%;
    width: 100%;
    filter: alpha(opacity=60);
  }

  .item {
    position: relative;
    z-index: 2;
  }
  .title {
    animation-delay: 0.5s;
    display: block;
  }
  .big {
    font-size: 60px;
    font-family: "PingFang SC", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 500;
    line-height: 102px;
    color: rgba(255, 255, 255, 1);
    display: block;
  }
  .small {
    font-size: 40px;
    font-family: "PingFang SC", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 400;
    line-height: 60px;
    color: rgba(204, 204, 204, 1);
    margin: 64px 0;
    display: block;
  }
  .con {
    display: block;
    animation-delay: 1s;
    width: 60% !important;
    font-size: 20px;
    font-family: "PingFang SC", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 400;
    line-height: 34px;
    color: rgba(204, 204, 204, 1);
    margin: auto;
  }
}
</style>
